import { mapGetters } from "vuex";

export default {
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters({
      currentQueueIndex: "queue/currentIndex",
      currentTrackId: "queue/currentTrackId",
      currentTracklist: "queue/tracklist",
      currentPlaylist: "player/playlist"
    }),
    paused() {
      return this.$player.paused;
    },
    running() {
      return this.$player.running;
    }
  },
  methods: {
    play() {
      if (this.tracklist.tracks && this.tracklist.tracks.length) {
        this.$player.play({
          index: this.index,
          tracklist: this.tracklist,
          toggle: true
        });
      } else {
        this.$message(this.$l10n("TRACKS_NOT_FOUNDED"));
      }
    },
    pause() {
      this.$player.pause();
    }
  }
};
